function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

import { addTelemetryDebug } from '@datadog/browser-core'; // Maximum number of requests to keep in the registry. Requests should be removed quite quickly in
// general, this is just a safety limit to avoid memory leaks in case of a bug.

export var MAX_REQUESTS = 1000;
export function createRequestRegistry(lifeCycle) {
  var requests = new Set();
  var subscription = lifeCycle.subscribe(8
  /* LifeCycleEventType.REQUEST_COMPLETED */
  , function (request) {
    requests.add(request);

    if (requests.size > MAX_REQUESTS) {
      addTelemetryDebug('Too many requests');
      requests["delete"](requests.values().next().value);
    }
  });
  return {
    getMatchingRequest: function getMatchingRequest(entry) {
      // Returns the closest request object that happened before the entry
      var minTimeDifference = Infinity;
      var closestRequest;

      var _iterator = _createForOfIteratorHelper(requests),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var request = _step.value;
          var timeDifference = entry.startTime - request.startClocks.relative;

          if (0 <= timeDifference && timeDifference < minTimeDifference && request.url === entry.name) {
            minTimeDifference = Math.abs(timeDifference);
            closestRequest = request;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (closestRequest) {
        requests["delete"](closestRequest);
      }

      return closestRequest;
    },
    stop: function stop() {
      subscription.unsubscribe();
    }
  };
}